import { dataHooks } from '../../../../libs/dataHooks';

export const templateFiltersDataHooks = dataHooks<{
  tooltip: {};
}>('template-filters');
